import refDataByKey from "../../../services/localRefData/refDataByKey.js";

// Los indicadores ISE 2 (ej. fieldStructure) se relevan en StmIse2Form, no acá.
// Ordenamos por id porque el refData puede llegar desordenado del API (sin ORDER BY).
export function getStmIseFields() {
  const biodiversityIndicators = refDataByKey("biodiversityIndicators") || [];
  return biodiversityIndicators
    .filter((indicator) => !indicator.isIse2Only)
    .sort((a, b) => a.id - b.id)
    .map((indicator) => ({
      id: indicator.id,
      label: indicator.es_AR,
      name: indicator.key,
      min: indicator.minValue,
      max: indicator.maxValue,
      step: indicator.step,
      default: "",
      enabled: false,
    }));
}
